import { useUserInfo } from 'pages/UserProvider';

/**
 * The company the portal user is currently spoofing, or `null` when they are on
 * their own company. Spoof state is never persisted, only derived from the selected
 * company diverging from the real one — `UserProvider` owns that derivation.
 *
 * Used to carry spoof into the embedded Presentations app (ENG-914): the
 * portal passes this to the iframe SSO URL and the deck-picker exchange so the
 * presentations session is scoped to the same company the portal is viewing.
 */
export function useSpoofedCompanyId(): string | null {
  const { spoofedCompanyId } = useUserInfo();
  return spoofedCompanyId;
}
